// -------------------------------------------------------------------
// --- ReportIssueModal.js (Ten kod powinien być w osobnym pliku) ---
// -------------------------------------------------------------------
import React, { useState, useEffect, useRef } from "react"; // Importy na górze pliku

const issueCategories = [
  "Błąd formatowania",
  "Obrazek nie pasuje do treści",
  "Obrazek się nie wczytał",
  "Błąd w treści zadania",
  "Nieprawidłowe rozwiązanie",
  "Pojęcia spoza zakresu maturalnego",
  "Zadania nie da się wykonać bez obliczeń na kartce",
  "Rozwiązanie jest zbyt szczegółowe",
  "Rozwiązanie jest zbyt mało szczegółowe",
  "Punkty źle przypisane do zadania",
];

const ReportIssueModal = ({ onClose, reportIssueData }) => {
  const [selectedIssueCategory, setSelectedIssueCategory] = useState("");
  const [reportDetails, setReportDetails] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const modalRef = useRef(null);
  const dropdownRef = useRef(null);

  const apiUrl = process.env.REACT_APP_API_SOURCE;
  const token = localStorage.getItem("token"); // Token jest też potrzebny tutaj

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        // Sprawdź, czy kliknięcie nie było na przycisku otwierającym dropdown, aby uniknąć natychmiastowego zamknięcia
        if (!dropdownRef.current?.contains(event.target)) {
             onClose();
        }
        return; // Zakończ, jeśli kliknięto poza modalem
      }
      // Zamknij dropdown, jeśli kliknięto poza nim, ale wewnątrz modala
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]); // Dodaj onClose jako zależność

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
        alert("Brak tokena autoryzacyjnego. Nie można zgłosić problemu.");
        return;
    }
     if (!selectedIssueCategory) {
       alert("Proszę wybrać kategorię problemu.");
       return;
     }
    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}report_issues/`, { // Upewnij się, że URL jest poprawny
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({
          field_id: reportIssueData.field_id,
          problem_id: reportIssueData.problem_id,
          report_category: selectedIssueCategory,
          report_details: reportDetails,
        }),
      });

      if (response.ok) {
        alert("Problem zgłoszony pomyślnie!");
        onClose(); // Zamknij modal po sukcesie
      } else {
        const data = await response.json().catch(() => ({ detail: "Nie udało się odczytać odpowiedzi serwera." })); // Próba odczytu JSON, fallback
        console.error("Błąd odpowiedzi serwera:", response.status, data);
        alert(`Wystąpił błąd podczas zgłaszania: ${data.detail || JSON.stringify(data)}`);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania zgłoszenia:", error);
      alert("Wystąpił błąd sieci lub serwera podczas zgłaszania problemu.");
    } finally { // Używamy finally, aby zawsze wyłączyć ładowanie
        setLoading(false);
    }
  };

  const handleSelectCategory = (cat) => {
    setSelectedIssueCategory(cat);
    setIsDropdownOpen(false); // Zamknij dropdown po wyborze
  };

  // Jeśli nie ma danych problemu, nie renderuj modala (zabezpieczenie)
  if (!reportIssueData) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-4">
      {/* Kontener modala */}
      <div ref={modalRef} className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md"> {/* Zwiększono max-w */}
        <h2 className="text-xl font-semibold mb-5 text-gray-800">
          Zgłoś problem z zadaniem (ID: {reportIssueData.problem_id})
        </h2>
        <form onSubmit={handleSubmit}>
          {/* Wybór kategorii */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Kategoria problemu <span className="text-red-500">*</span>
            </label>
            <div className="relative" ref={dropdownRef}>
              <button
                type="button"
                className="w-full border border-gray-300 rounded p-2 text-left bg-white flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                 aria-haspopup="listbox"
                 aria-expanded={isDropdownOpen}
              >
                <span className={selectedIssueCategory ? "text-gray-900" : "text-gray-500"}>
                 {selectedIssueCategory ? selectedIssueCategory : "Wybierz kategorię..."}
                </span>
                 {/* Ikona strzałki */}
                 <svg className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${isDropdownOpen ? 'transform rotate-180' : ''}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                 </svg>
              </button>
              {isDropdownOpen && (
                <div className="absolute w-full bg-white border border-gray-200 mt-1 rounded shadow-lg z-10 max-h-60 overflow-y-auto"> {/* Ograniczenie wysokości i scroll */}
                  {issueCategories.map((cat, index) => (
                    <div
                      key={index}
                      className="p-2 hover:bg-blue-50 cursor-pointer text-sm leading-tight break-words"
                      onClick={() => handleSelectCategory(cat)}
                      role="option"
                      aria-selected={selectedIssueCategory === cat}
                    >
                      {cat}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Pole na dodatkowe informacje */}
          <div className="mb-5">
            <label htmlFor="reportDetails" className="block text-sm font-medium text-gray-700 mb-1">
              Szczegóły (opcjonalnie)
            </label>
            <textarea
              id="reportDetails"
              value={reportDetails}
              onChange={(e) => setReportDetails(e.target.value)}
              className="w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              rows="4" // Zwiększono liczbę wierszy
              placeholder="Opisz problem bardziej szczegółowo..."
            />
          </div>

          {/* Przyciski */}
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded bg-gray-200 text-gray-800 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1"
              disabled={loading}
            >
              Anuluj
            </button>
            <button
              type="submit"
              className={`px-4 py-2 rounded text-white font-semibold focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 ${
                loading || !selectedIssueCategory
                  ? "bg-blue-300 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
              disabled={loading || !selectedIssueCategory} // Wyłącz, jeśli ładuje lub nie wybrano kategorii
            >
              {loading ? "Wysyłanie..." : "Zgłoś problem"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportIssueModal; // Eksport na końcu pliku